/**
 * Component for toggling between two different UI treatments
 *
 * The selection is persisted using the edxUxPreferenceService
 */
(function(){
  angular.module("rightPaneModule")
    .directive("edxUxToggle", function(){
      return {
        restrict: 'E',
        scope: {
          /** Unique key for this choice.  Needs to match key used with edxUxPreferenceService */
          uxKey: '=edxUxKey',

          /** The display string for treatment 1 */
          treatment1Display: '=edxTreatment1Display',

          /** Value stored in edxUxPreferenceService when treatment 1 is selected */
          treatment1Value: '=edxTreatment1Value',

          /** The display string for treatment 2 */
          treatment2Display: '=edxTreatment2Display',

          /** Value stored in edxUxPreferenceService when treatment 2 is selected */
          treatment2Value: '=edxTreatment2Value',

          /** Default treatment value if no selection has been made */
          defaultValue: '=edxDefaultValue',

          analyticsEvent: '=edxAnalyticsEvent'
        },
        templateUrl: '/resources/right-pane/components/ux-toggle/ux-toggle.component.html',
        controller: ['edxUxPreferenceService', 'dblAnalyticsProvider', 'authentication', UxToggleController],
        controllerAs: 'vm',
        bindToController: true
      };
    });

  function UxToggleController(uxPreferenceService, analyticsService, authentication) {
    var vm = this;
    vm.getActiveValue = getActiveValue;
    vm.onClick = onClick;

    /** Get the value currently set for the UX option key */
    function getActiveValue() {
      return uxPreferenceService.getPreference(vm.uxKey, vm.defaultValue);
    }

    if (authentication.useBts2020Nav() && vm.uxKey === 'cl.o.s') {
      uxPreferenceService.savePreference(vm.uxKey, vm.defaultValue);
    }
    /** UI clicked to change treatment */
    function onClick(treatmentValue) {
      if (getActiveValue() !== treatmentValue) {
        uxPreferenceService.savePreference(vm.uxKey, treatmentValue).then(function () {
          var treatment = treatmentValue === vm.treatment1Value ? vm.treatment1Display
            : treatmentValue = vm.treatment2Value ? vm.treatment2Display
              : 'error';

          analyticsService.eventTrack(vm.analyticsEvent || vm.uxKey, {
            category: treatment,
            label: 'UX Selection'
          });
        });
      }
    }
  }
})();
